<template>
  <div class="tva-slider-images-component">
    <div v-for="(chapter, index) in content" :key="index" :class="['slide']">
      <div v-if="$tvaMq !== 'mobile'">
        <transition name="fade">
          <div
            v-if="currentIndex === index"
            :class="['background-image']"
            :style="{backgroundImage: `url(${baseUrl}images/${chapter.img}${$retina ? '@2x' : ''}${$tvaMq === 'mobile' ? '_m' : ''}.jpg)`}"
          >
            <div :class="['gradient-image']"></div>
            <div class="slide-content">
              <p class="text-overlay-800">{{chapter.title}}</p>
              <img :src="`${baseUrl}images/${chapter.svg}.svg`">
              <p class="text-overlay">{{chapter.text}}</p>
              <div class="buttons">
                <div class="tva-prev-button" @click="setCurrentIndex('prev')"></div>
                <div class="tva-next-button" @click="setCurrentIndex('next')"></div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div v-if="$tvaMq === 'mobile'">
        <transition name="fade">
          <div v-if="currentIndex === index">
            <div
              :class="['background-image']"
              :style="{backgroundImage: `url(${baseUrl}images/${chapter.img}${$retina ? '@2x' : ''}${$tvaMq === 'mobile' ? '_m' : ''}.jpg)`}"
            ></div>
            <div class="slide-content">
              <p class="text-overlay-800">{{chapter.title}}</p>
              <img :src="`${baseUrl}images/${chapter.svg}.svg`">
              <p class="text-overlay">{{chapter.text}}</p>
              <div class="buttons">
                <div class="tva-prev-button" @click="setCurrentIndex('prev')"></div>
                <div class="tva-next-button" @click="setCurrentIndex('next')"></div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="points">
      <div
        v-for="(el, index) in content"
        :key="index+'point'"
        :class="['point', {'active': currentIndex === index}]"
      ></div>
    </div>
  </div>
</template>
<script>
import TvaParallax from "../utilities/TvaParallax.vue";
export default {
  props: ["content"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      currentIndex: 0
    };
  },
  methods: {
    setCurrentIndex(value) {
      if (value === "prev") {
        if (this.currentIndex === 0) {
          this.currentIndex = 2;
        } else {
          this.currentIndex = this.currentIndex - 1;
        }
      } else if (value === "next") {
        if (this.currentIndex === 2) {
          this.currentIndex = 0;
        } else {
          this.currentIndex = this.currentIndex + 1;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";
@import "../assets/scss/buttons.scss";
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s ease;
  .slide-content p {
    transition: all 0.5s ease;
  }
}
.fade-enter {
  opacity: 0;
  .slide-content p {
    transform: translateX(-100px);
    opacity: 0;
  }
}
.fade-leave-to {
  opacity: 0;
  .slide-content p {
    transform: translateX(20px);
    opacity: 0;
  }
}
.tva-slider-images-component {
  height: 600px;
  width: 100vw;
  position: relative;
  overflow: hidden;
  margin-bottom: 100px;
  .slide {
    height: 100%;
    width: 100%;
    background: black;
    .gradient-image {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 0;
      background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.9) 0%,
        rgba(0, 0, 0, 0) 100%
      );
    }
    .background-image {
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-size: cover;
      background-position: 20% 30%;
      display: flex;
      padding: 5%;
      .slide-content {
        z-index: 1;
        width: 30%;
        p {
          text-align: left;
        }
        img {
          height: 180px;
          margin: 30px 0;
        }
        .buttons {
          position: absolute;
          left: 5%;
          bottom: 50px;
          display: flex;
          justify-content: space-between;
          width: 80px;
          margin-top: 30px;
        }
      }
    }
  }
  .points {
    position: absolute;
    bottom: 30px;
    left: calc(50% - 50px);
    width: 100px;
    display: flex;
    .point {
      height: 10px;
      width: 10px;
      background: transparent;
      border: solid 1px white;
      border-radius: 50%;
      margin: 0 10px;
      &.active {
        background: white;
      }
    }
  }
}
@media (max-width: 1024px) {
  .tva-slider-images-component {
    height: 60vh;
    min-height: 600px;
    .slide {
      .gradient-image {
        background: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0.1) 0%,
          rgba(0, 0, 0, 1) 90%,
          rgba(0, 0, 0, 1) 100%
        );
      }
      .background-image {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: unset;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .slide-content {
          width: 50%;
          img {
            height: 150px;
            margin: 10px 0;
          }
        }
      }
    }
  }
}
@media (max-width: 720px) {
  .tva-slider-images-component {
    height: 75vh !important;
    min-height: unset;
    margin-bottom: 0;
    .slide {
      .gradient-image {
        background: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.9) 70%,
          rgba(0, 0, 0, 1) 100%
        );
      }
      .background-image {
        position: absolute;
        top: 0;
        left: 0;
        filter: none;
        background-repeat: no-repeat;
        background-size: cover !important;
        background-position: 0% 0% !important;
        width: 100vw;
        height: 200px;
        z-index: 3;
        overflow: visible;
        &::after {
          content: "";
          width: 100%;
          height: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0) 79%,
            rgba(0, 0, 0, 0.05) 80%,
            rgba(0, 0, 0, 1) 100%
          );
        }
      }
      .slide-content {
        position: absolute;
        top: 200px;
        height: calc(100% - 230px);
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 20px;
        img {
          display: none;
        }
        p {
          text-align: center;
          margin-bottom: 50px;
          padding: 0 10px;
          &.text-overlay-800 {
            margin-bottom: 10px;
          }
        }
        .buttons {
          width: 100vw;
          display: flex;
          justify-content: space-between;
          position: absolute;
          bottom: 0px;
          left: 0;
          width: 100%;
          margin-top: 40px;
          padding: 0 30px;
        }
      }
    }
    .points {
      bottom: 40px;
    }
  }
}
</style>


